import * as React from 'react';
import cn from 'classnames';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../theme';
import Input from '../../Input';
import { emailRegex, useIsMobile } from '../../utils';

interface Props {
	className?: string;
	defaultEmail?: string;
	onSubmit?: (values: any) => void;
	submitRef?: React.MutableRefObject<(() => void) | undefined>;
}

const ResendTicketsForm: React.FC<Props> = ({ className, defaultEmail, onSubmit, submitRef }) => {
	const { ResendTicketsForm: css } = useTheme('ResendTicketsForm');
	const { t } = useTranslation('RegisteredPassenger');

	const isMobile = useIsMobile();

	return (
		<div className={cn(className, css.wrapper)}>
			<Form
				onSubmit={onSubmit}
				initialValues={{ email: defaultEmail }}
				render={({ handleSubmit, form }) => {
					if (submitRef) {
						submitRef.current = () => {
							form.submit();
						};
					}

					return (
						<form onSubmit={handleSubmit}>
							<Field
								name={'email'}
								validate={(value: string): string | void => {
									if (!value) {
										return t('Required field') as string;
									}

									if (!emailRegex.test(value)) {
										return t('Please enter a valid email') as string;
									}
								}}
								render={({ input, meta }) => {
									const validationError = meta.touched && meta.error ? meta.error : undefined;
									const submitError =
										meta.submitError && !meta.dirtySinceLastSubmit ? meta.submitError : undefined;

									const fieldError = validationError || submitError;
									const helperText = fieldError || '';

									return (
										<Input
											{...input}
											inputClassName={cn(css.input, css.input_underline)}
											inputFocusedClassName={css.input_focused}
											variant={isMobile ? 'standard' : 'filled'}
											label={t('Email')}
											TextFieldProps={{
												error: Boolean(fieldError),
												helperText: <span className={css.error}>{helperText}</span>,
												onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
													input.onChange(event);
												}
											}}
										/>
									);
								}}
							/>
						</form>
					);
				}}
			/>
		</div>
	);
};

export default ResendTicketsForm;
